import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

/**
 * The status bar is drawn by the OS, outside the WebView, so it never picks
 * up the app's own dark/light styling on its own. Left alone it shows dark
 * icons over the app's dark backgrounds and disappears.
 */
export function installNativeStatusBar(): void {
  if (!Capacitor.isNativePlatform()) return;
  void StatusBar.setOverlaysWebView({ overlay: false });
}

/** Called whenever AppLayout resolves the theme actually on screen. */
export function syncNativeStatusBarTheme(theme: 'light' | 'dark'): void {
  if (!Capacitor.isNativePlatform()) return;
  // Style.Dark means light icons for a dark background, which is what a
  // 'dark' app theme needs; the naming is from the icon colour, not the
  // background, and reads backwards on first glance.
  void StatusBar.setStyle({ style: theme === 'dark' ? Style.Dark : Style.Light });
}
